import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import {
  applyTokens,
  buildThemeBlock,
  clearTokens,
  DEFAULTS,
  type Oklch,
  type ThemeLabValues,
} from './theme-lab-tokens'

interface ThemeLabStore extends ThemeLabValues {
  open: boolean
  setOpen: (open: boolean) => void
  toggleOpen: () => void
  patch: (partial: Partial<ThemeLabValues>) => void
  setBrand: (partial: Partial<Oklch>) => void
  reset: () => void
  apply: () => void
  exportBlock: () => string
}

export const useThemeLabStore = create<ThemeLabStore>()(
  persist(
    (set, get) => ({
      ...DEFAULTS,
      open: false,

      setOpen: (open) => set({ open }),
      toggleOpen: () => set((s) => ({ open: !s.open })),

      patch: (partial) =>
        set((s) => {
          const next = { ...s, ...partial }
          applyTokens(next)
          return next
        }),

      setBrand: (partial) =>
        set((s) => {
          const next = { ...s, brand: { ...s.brand, ...partial } }
          applyTokens(next)
          return next
        }),

      reset: () => {
        clearTokens()
        set({ ...DEFAULTS })
      },

      apply: () => applyTokens(get()),
      exportBlock: () => buildThemeBlock(get()),
    }),
    {
      name: 'precedent-theme-lab',
      partialize: (s) => ({
        rampHue: s.rampHue,
        chromaMul: s.chromaMul,
        brand: s.brand,
        radius: s.radius,
        displayWeight: s.displayWeight,
        fontSans: s.fontSans,
        fontHeading: s.fontHeading,
      }),
      // applyTokens runs from ThemeLabMount after hydration — not here, to avoid
      // imperative body/html style updates during React hydration.
    },
  ),
)
